import axios from "axios";
import { API_URL } from "../../constants";
import _ from "lodash";

export default {
  getPlanAgainstProduct: (uuid, status) => {
    return axios.get(`${API_URL.PLAN_AGAINST_PRODUCT}/${uuid}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        product_plan_status: status,
      },
    });
  },
  getProductPricing: (uuid) => {
    return axios.get(`${API_URL.PRICING}/${uuid}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  updatePricing: (uuid, data) => {
    return axios.get(`${API_URL.PRICING}/${uuid}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  createPricing: (data) => {
    return axios.post(API_URL.PRICING, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  updatePricing: (uuid, data) => {
    return axios.patch(`${API_URL.PRICING}/${uuid}`, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  updateStatus: (uuid, data) => {
    return axios.patch(`${API_URL.PRICING}/status/${uuid}`, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  createPricing: (data) => {
    return axios.post(API_URL.PRICING, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  getAllPricing: (page, pageSize, searchparams) => {
    console.log("1");
    
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axios.get(`${API_URL.PRICING}/packages`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        page: page,
        pageSize: pageSize,
        ...filteredParams,
      },
    });
  },
  getOngoingPricing: (id) => {
    console.log("2")
    return axios.get(`${API_URL.PRICING}/packages/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
